import _ from 'lodash';
import { publicResources } from '../public-resources';

function preloadImages(urls) {
  if (urls == null || !_.isArray(urls)) return;

  // eslint-disable-next-line no-array-constructor, no-undef
  let images = window.preloadedImages ?? [];

  images = images.concat(
    urls.map((url) => {
      // eslint-disable-next-line no-undef
      const image = new Image();
      image.src = url;

      return image;
    })
  );

  // eslint-disable-next-line no-undef
  window.preloadedImages = images;
}

function preloadPublicImages() {
  const urls = _.values(publicResources.image);
  preloadImages(urls);
}

export { preloadImages, preloadPublicImages };
